import { useState } from "react";
import { useTeamLogos } from "../lib/logos";

const SIZES = {
  xs: "h-4 w-4 text-[7px]", sm: "h-5 w-5 text-[8px]", md: "h-7 w-7 text-[10px]",
  lg: "h-9 w-9 text-xs", xl: "h-11 w-11 text-sm", "2xl": "h-14 w-14 text-base",
};

// Team logo; falls back to the colored abbreviation badge when no logo exists.
export const TeamLogo = ({ sport, abbr, color = "#233248", size = "md", logo, className = "", testId }) => {
  const logos = useTeamLogos(logo ? null : sport);
  const [broken, setBroken] = useState(false);
  const src = logo || logos[(abbr || "").toUpperCase()];
  const sz = SIZES[size] || SIZES.md;
  if (src && !broken) {
    return (
      <img src={src} alt={abbr} title={abbr} data-testid={testId} onError={() => setBroken(true)}
        className={`${sz} object-contain shrink-0 rounded-full bg-slate-100/90 p-[2px] ${className}`} />
    );
  }
  return (
    <span data-testid={testId} style={{ background: color }}
      className={`${sz} rounded-md grid place-items-center font-heading font-extrabold text-white shrink-0 ${className}`}>
      {abbr}
    </span>
  );
};

// "SF @ ATL" -> logo @ logo. Anything else is shown as plain text.
export const GameLabel = ({ sport, label, size = "sm", className = "" }) => {
  const m = /^(\S+)\s+(@|vs\.?)\s+(\S+)$/i.exec((label || "").trim());
  if (!m) return <span className={className}>{label}</span>;
  return (
    <span className={`inline-flex items-center gap-1 align-middle ${className}`}>
      <TeamLogo sport={sport} abbr={m[1]} size={size} />
      <span className="text-slate-500">{m[2]}</span>
      <TeamLogo sport={sport} abbr={m[3]} size={size} />
    </span>
  );
};
